<iframe
  class="flex grow"
  [src]="sourceSanitized()"
  [title]="title"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  referrerpolicy="strict-origin-when-cross-origin"
  allowfullscreen
  anonymous
></iframe>
